import { render, staticRenderFns } from "./QuestionCollections.vue?vue&type=template&id=1e99848e&"
import script from "./QuestionCollections.vue?vue&type=script&lang=ts&"
export * from "./QuestionCollections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports